module.exports = __webpack_public_path__ + "img/feb6877.png";